import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import MuiButton from '@material-ui/core/Button';

import { useButtonStyles } from './styles';

const Button = ({ children, bold, noTextTransform, fullWidth, width, height, ...rest }) => {
	const classes = useButtonStyles({
		bold,
		noTextTransform,
		width,
		height,
		rest
	});
	const progressActive = useSelector(state => state.tabbar.progressActive);

	return (
		<MuiButton
			disabled={progressActive || rest.disabled}
			disableElevation
			width={fullWidth ? '100%' : width || 'auto'}
			height={height || 'auto'}
			classes={classes}
			{...rest}>
			{children}
		</MuiButton>
	);
};

Button.propTypes = {
	children: PropTypes.node.isRequired,
	bold: PropTypes.bool,
	fullWidth: PropTypes.bool,
	width: PropTypes.number,
	height: PropTypes.number
};

export default Button;
